module.exports = __webpack_public_path__ + "img/logo-mirt.4f0764a0.svg";